import { render, staticRenderFns } from "./PendingConsentList.vue?vue&type=template&id=0c68d85c&"
import script from "./PendingConsentList.vue?vue&type=script&lang=js&"
export * from "./PendingConsentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports